export default __webpack_public_path__ + "static/media/Logotipi.1403cc82.png";